<template>
  <transition name="fade">
    <div :class="bemClass()"
         v-if="isActive"
         @click.prevent="$emit('click')"
    ></div>
  </transition>
</template>

<script>
import useBem from '../../compositions/bem'
import { toRefs } from 'vue'

export default {
  name: 'SelBackdrop',
  emits: ['click'],
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    modifier: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const { modifier } = toRefs(props)
    const { bemClass } = useBem('sel-backdrop', modifier)

    return {
      bemClass
    }
  }
}
</script>

<style scoped>
.sel-backdrop {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 1;
}
</style>
